import React from 'react';

import NavBarNameForm from '@dashboard/components/NavBarNameForm';
import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useUpdateWorkflowNameMutation, useWorkflowQuery } from '@dashboard/generated/wp/platform';

import useCurrentWorkflowId from './useCurrentWorkflowId';

export default function NavBarName() {
  const id = useCurrentWorkflowId();
  const { data } = useWorkflowQuery({ variables: { id } });
  const [updateName, { loading }] = useUpdateWorkflowNameMutation();

  const workflow = data?.Workflow;
  if (!workflow) {
    return null;
  }
  const onSubmit = async (name: string) => {
    try {
      const n = name.trim().length === 0 ? 'Untitled workflow' : name.trim();
      await updateName({ variables: { id, name: n } });
      alertSuccess('Workflow name saved');
      return true;
    } catch (e) {
      alertError('Workflow name not saved');
      return false;
    }
  };
  const { name } = workflow;
  return <NavBarNameForm key={name} onSave={onSubmit} initialValue={name} loading={loading} />;
}
